// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  MenuItem,
  InputLabel,
  Select,
  FormControl,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
// import MDBadge from "theme/components/MDBadge";
import MDInput from "theme/components/MDInput";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import MDButton from "theme/components/MDButton";
// import ApiConfig from "apiConfig";
import usePageTitle from "app/pageTitle";
import CompanyNotification from "app/company_notification";

function GiftCards() {
  const pageTitle = "Gift Cards";
  usePageTitle(pageTitle);

  const navigate = useNavigate();
  const [refreshPage, setRefreshPage] = useState(false);

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [countries, setCountries] = useState([]);

  const [searchName, setSearchName] = useState(null);
  const [searchCountry, setSearchCountry] = useState(null);
  const [giftCards, setGiftCards] = useState([]);

  const [showCompanyNotification, setShowCompanyNotification] = useState(false);
  const [companyNotification, setCompanyNotification] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("giftcards/search/init.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCountries(result.data.data.countries);

            if (result.data.notification) {
              setCompanyNotification(result.data.notification);
              if (result.data.notification.pages.includes("ALL")) {
                setShowCompanyNotification(true);
              } else if (result.data.notification.pages.includes("gift_cards")) {
                setShowCompanyNotification(true);
              }
            }
            setRefreshPage(refreshPage);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again later.");
          setOpen(true);
        });
    };

    fetchData();
  }, [refreshPage]);

  async function searchGiftCards() {
    const searchParams = {};
    if (searchName !== null) {
      searchParams.name = searchName;
    }

    if (searchCountry !== null) {
      searchParams.country = searchCountry;
    }

    if (searchName === null && searchCountry === null) {
      setSeverity("error");
      setErrMsg("Country or gift card name is required");
      setOpen(true);
      return;
    }

    setShowLoading(true);
    const json = JSON.stringify(searchParams);
    await axios
      .post("giftcards/search.json", json)
      .then((result) => {
        // console.log(result);
        setShowLoading(false);
        if (result.data.status === "success") {
          setGiftCards(result.data.data.gift_cards);
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred. Please try again later.");
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {companyNotification !== null && showCompanyNotification ? (
        <CompanyNotification
          title={companyNotification.title}
          description={companyNotification.description}
        />
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <MDBox mb={5}>
          <Card>
            <MDBox pt={3} pb={2} px={2}>
              <MDTypography variant="h5">Search for a gift card to buy</MDTypography>
              <MDBox mt={4}>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6} lg={6}>
                    <MDBox>
                      <MDInput
                        onChange={(e) => {
                          setSearchName(e.target.value);
                        }}
                        name="name"
                        label="Gift card name"
                        sx={{ minWidth: 120, width: "100%" }}
                      />
                    </MDBox>
                  </Grid>
                  <Grid item xs={12} md={6} lg={6}>
                    <FormControl sx={{ minWidth: 120, width: "100%" }}>
                      <InputLabel>Country</InputLabel>
                      <Select
                        label="Country"
                        name="country"
                        sx={{ padding: "12px", paddingLeft: "3px" }}
                        onChange={(e) => setSearchCountry(e.target.value)}
                      >
                        {
                          // --> Notice below changes
                          countries.length > 0 && // --> Changes from `options.length ? ...` to `options.length > 0 && ...`
                            countries.map((record) => (
                              <MenuItem value={record.code}>
                                <MDBox display="flex" alignItems="center" justifyContent="left">
                                  <img alt="" src={record.flag} width="20" mr={3} />
                                  <MDBox ml={2}>{record.title}</MDBox>
                                </MDBox>
                              </MenuItem>
                            ))
                        }
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </MDBox>
              <MDBox mt={4}>
                <MDButton
                  variant="contained"
                  color="info"
                  onClick={() => {
                    searchGiftCards();
                  }}
                >
                  Search
                </MDButton>
              </MDBox>
            </MDBox>
          </Card>
        </MDBox>
        <Grid container spacing={4}>
          {giftCards.length <= 0 ? (
            <Grid item xs={12} md={12} lg={12}>
              <Card>
                <MDBox pt={3} pb={2} px={2}>
                  <MDBox
                    component="ul"
                    display="flex"
                    flexDirection="column"
                    p={0}
                    m={0}
                    sx={{ listStyle: "none" }}
                  >
                    <small>Search for a gift card to purchase.</small>
                  </MDBox>
                </MDBox>
              </Card>
            </Grid>
          ) : (
            <>
              {giftCards.map((giftcard) => (
                <Grid item xs={12} md={3} lg={3}>
                  <Card>
                    <MDBox
                      width="100%"
                      display="flex"
                      flexDirection="column"
                      justifyContent="center"
                      p={3}
                      onClick={() => {
                        navigate(`/giftcards/${giftcard.reference}`);
                      }}
                    >
                      <MDBox component="img" src={giftcard.logo} alt={giftcard.title} />
                      <MDBox mt={2}>
                        <MDBox display="flex" alignItems="center" justifyContent="space-between">
                          <img alt="" src={giftcard.country.flag} width="20" mr={3} />
                          <MDTypography ml={2} variant="caption" fontWeight="medium">
                            {giftcard.country.title}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    </MDBox>
                  </Card>
                </Grid>
              ))}
            </>
          )}
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default GiftCards;
